module.exports = __webpack_public_path__ + "static/media/landeshauptstadt.5e9b8195.png";